import { BoxFlex } from '../../../atoms/boxSpaceBtw';
import { useIsTablet } from '../../../utils/hooks/useIsMobile';
import CalenderPickerDialog from '../../calender-picker-dialog/calenderPickerDialog';
import DatePickerField from '../../../atoms/date-picker-field';
import { useState } from 'react';
import { CalenderTypes } from '../project-cards-page';
import { currenciesList } from './helper';
import { LocalDayjs } from '../../../utils/timezoneService';
import DropDownDrawerWithChip from '../../dropdown-drawer-with-chip';
import DropDownFilter from '../../../atoms/drop-down-filter';
import { useExchangeRateContext } from '../../../pages/exchange-rate/context';

const ExchangeRateNavbarItems = () => {

    // Making tablet screen like mobile
    const isMobile = useIsTablet();
    const { filters, setFilters } = useExchangeRateContext();
    const [isCalender, setCalender] = useState<CalenderTypes>({
        open: false,
        value: "",
        type: "",
        date: null,
        tDate: null,
        select: null
    });

    const calenderOpenClickHandler = () => {
        setCalender((prev: any) => ({ ...prev, open: true }));
    };
    const calenderCloseBtnClickHandler = () => {
        setCalender((prev: any) => ({
            ...prev,
            open: false,
            value: "",
            date: null,
            tDate: null,
            select: null
        }));
        setFilters((prev) => ({
            ...prev,
            dateRange: null,
            dateRangeType: null,
            isFilterChange: true
        }));
    };

    return (
        <BoxFlex sx={{
            "& p": {
                fontSize: "0.75rem"
            },
            marginBottom: "0.25rem"
        }}>
            {isMobile ?
                <DropDownDrawerWithChip
                    chipLabel="Currency"
                    isClearDisabled
                    value={filters.currency}
                    listArr={currenciesList}
                    onItemSelect={(currency: string | null) => {
                        setFilters((prev) => ({ ...prev, currency: currency || "all", isFilterApplied: true, isFilterChange: true }))
                    }}
                />
                :
                <>
                    <p className="sort">Currency:</p>
                    <DropDownFilter
                        setFilterPayload={(currency: string) => {
                            setFilters((prev) => ({ ...prev, currency, isFilterApplied: true, isFilterChange: true }))
                        }}
                        dropDownItems={currenciesList}
                        filterValue={filters.currency}
                        noMinWidth
                    />
                </>}
            <BoxFlex sx={{ maxWidth: "400px" }}>
                <DatePickerField
                    label={"Date:"}
                    isCalenderValue={isCalender.value}
                    calenderOpenClickHandler={calenderOpenClickHandler}
                    calenderCloseBtnClickHandler={calenderCloseBtnClickHandler}
                    isMobile={isMobile}
                />
            </BoxFlex>

            {/* Calender Picker Dialog */}
            {isCalender.open &&
                <CalenderPickerDialog
                    isOpen={isCalender.open}
                    handleClose={() =>
                        setCalender((prev: any) => ({ ...prev, open: false }))
                    }
                    setCalender={setCalender}
                    select={isCalender.select}
                    startDate={isCalender.date}
                    endDate={isCalender.tDate}
                    okBtnApiCalls={(
                        date: Date | null,
                        tDate: Date | null,
                        select: "between" | "on" | "before" | "after" | null,
                        calenderType: string | null
                    ) => {
                        let dateRange = '';
                        const date_url = date ? `startDate=${LocalDayjs(date).format("YYYY-MM-DD")}` : "";
                        const tDate_url = tDate ? `endDate=${LocalDayjs(tDate).format("YYYY-MM-DD")}` : "";
                        switch(select) {
                            case 'on':
                                dateRange = date ? `date=${LocalDayjs(date).format("YYYY-MM-DD")}` : '';
                                break;
                            case 'between':
                                dateRange = `${date_url}&${tDate_url}`; 
                                break;
                            case 'before':
                                dateRange = date ? `endDate=${LocalDayjs(date).format("YYYY-MM-DD")}` : '';
                                break;
                            case 'after':
                                dateRange = date ? `startDate=${LocalDayjs(date).format("YYYY-MM-DD")}` : '';
                                break;
                        }

                        setFilters((prev) => ({
                            ...prev,
                            dateRange,
                            isFilterApplied: true,
                            isFilterChange: true
                        }));
                    }}
                    calenderType={isCalender.type}
                    singleTitle='Date'
                    titleRadioBtns={[
                        { label: 'On', value: 'on' },
                        { label: 'Between', value: 'between' },
                        { label: 'Before', value: 'before' },
                        { label: 'After', value: 'after' }
                    ]}

                    resetCalenderBtnClickHandler={calenderCloseBtnClickHandler}
                    allowedTabs={['on', 'between', 'before', 'after']}
                />
            }
        </BoxFlex>
    )
}

export default ExchangeRateNavbarItems